import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { formatCurrency } from '../../../../../../../helpers/numbers'

import { selectedTikTokAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { BUDGET } from '../../../../../../Tiktok/CampaignForms/CampaignTikTokEdit/fields'
import { BUDGET_MODE_TOTAL, BUYING_TYPE } from '../../../../../../Tiktok/fields'

const BudgetPreview = ({ lineItem }) => {
  const { t } = useTranslation()

  const { currency_symbol: currencySymbol } = useSelector(selectedTikTokAdAccountSelector)

  const { [BUDGET]: budget } = lineItem

  const formattedBudget = formatCurrency(budget, { min: 2, max: 2 }, { symbol: currencySymbol })
  const budgetTypeLabel = lineItem[BUYING_TYPE] === BUDGET_MODE_TOTAL ? t('Lifetime') : t('Daily')

  if (budget) {
    return (
      <span>
        {formattedBudget} ({budgetTypeLabel})
      </span>
    )
  }

  if (!budget) {
    return <span>{t('Campaign level budget is set')}</span>
  }

  return null
}

export default BudgetPreview
